module.exports = [
  'Start',
  'FirstQuartile',
  'Midpoint',
  'ThirdQuartile',
  'Complete'
]



// WEBPACK FOOTER //
// ./components/linearAds/vpaid-life-cycle.js